import { EnvelopeIcon, UserCircleIcon } from '@gto/ui/icons/outline'
import { Typography } from '@gto/ui/typography'

import type { UserUnverifiedReport } from '@/api/gen'

export const UnverifiedAccountCard = ({
  report: { report_date, username, email_address, poker_room },
}: {
  report: UserUnverifiedReport
}) => {
  return (
    <>
      <div className="flex h-full flex-col gap-6">
        <div className="flex grow flex-col gap-2">
          <div className="flex items-center justify-between gap-4">
            <Typography
              className="[word-break:break-word]"
              variant="body2"
            >
              {poker_room}
            </Typography>
            <Typography
              className="flex-[0_0_auto]"
              color="text.ghost"
              variant="body4"
            >
              {report_date}
            </Typography>
          </div>
          <div className="flex items-center gap-4">
            <Typography
              noWrap
              color="text.ghost"
              variant="body3"
            >
              <UserCircleIcon
                height={16}
                style={{ verticalAlign: 'middle' }}
                width={16}
              />
              <Typography
                className="ml-1 [font-size:inherit]"
                color="text.secondary"
                component="span"
              >
                {username || '-'}
              </Typography>
            </Typography>
            <Typography
              noWrap
              color="text.ghost"
              variant="body3"
            >
              <EnvelopeIcon
                height={16}
                style={{ verticalAlign: 'middle' }}
                width={16}
              />
              <Typography
                className="ml-1.5 [font-size:inherit]"
                color="text.secondary"
                component="span"
              >
                {email_address || '-'}
              </Typography>
            </Typography>
          </div>
        </div>
      </div>
    </>
  )
}
